import { useGetUserListsQuery } from 'api/userLists'
import { useCallback, useState } from 'react'

const PER_PAGE = 25

export function useUserListSearch() {
  const [query, setQuery] = useState('')
  const [page, setPage] = useState(1)

  const { data, isLoading, isFetching } = useGetUserListsQuery({
    page,
    per_page: PER_PAGE,
    query: query || undefined,
  })

  const handleSearchChange = useCallback((value: string) => {
    setQuery(value)
    setPage(1)
  }, [])

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage)
  }, [])

  return {
    lists: data?.data || [],
    isLoading,
    isFetching,
    pagination: data?.pagination,
    totalCount: data?.pagination?.total_count ?? 0,
    handleSearchChange,
    handlePageChange,
  }
}
